<template>
  <div>
    <input type="text" v-model="content" :list="`${id}_suggestions`" :placeholder="placeholder" :class="inputClass" />
    <datalist :id="`${id}_suggestions`">
      <option v-for="(suggestion, i) in filteredOptions" :key="i" :value="suggestion.id">
        {{ suggestion.name }}
      </option>
    </datalist>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { debounce } from 'lodash'
import randomstring from 'randomstring'

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    country: {
      type: String,
      default: 'GB'
    },
    withAreas: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: 'w-full bg-white rounded h-10 py-0 px-2 shadow text-sm border text-grey-darkest'
    }
  },
  data () {
    return {
      id: randomstring.generate(),
      suggestions: [],
      content: this.value
    }
  },
  computed: {
    filteredOptions () {
      let options = this.withAreas ? this.suggestions : this.suggestions.filter((s) => !s.is_area)
      return options.map((s) => {
        let name = s.name
        if (s.is_area) {
          name += ' and surroundings'
        }

        return {
          id: s.name,
          name: name
        }
      })
    }
  },
  methods: {
    getSuggestions: debounce(function () {
      v2Api.get('localities/suggest', {
        params: {
          address_country: this.country,
          q: this.content
        }
      }).then((response) => {
        this.suggestions = response.data
      })
    }, 200),
    reset () {
      this.content = ''
    }
  },
  watch: {
    content (val) {
      this.getSuggestions()
      this.$emit('input', val)
    }
  }
}
</script>
